import Popup from "reactjs-popup";
import "./styles.css";
import closeIcon from "../../../assets/icons/icons-close.svg";
import searchIcon from "../../../assets/images/searchIcon.svg";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DateInput from "../../../ui/DateInput";
import Button from "../../../ui/Button.jsx";
import { convertToUnix } from "../../../utils/utils";
import { statmentAdvanceSearchDefaultValues } from "../../../lib/constants/index.js";
import { convertToIranianDate } from "../../../mini_components/ConvertToJalali.js";
import icons from "../../../lib/icons/index.js";

const AdvanceSearchBtn = ({ setSearchTerm }) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: statmentAdvanceSearchDefaultValues,
  });

  const processForm = (data, close) => {
    if (
      convertToUnix(data.min_created_at) > convertToUnix(data.max_created_at)
    ) {
      toast.error("تاریخ شروع باید قبل تر از تاریخ اتمام باشد ");
      return;
    }

    const processedData = {
      ...data,
      min_created_at: data.min_created_at
        ? convertToIranianDate(data.min_created_at)
        : "",
      max_created_at: data.max_created_at
        ? convertToIranianDate(data.max_created_at)
        : "",
    };

    setSearchTerm(processedData);
    close();
    // reset();
  };

  return (
    <>
      <Popup
        trigger={
          <div className="cursor-pointer flex justify-center items-center px-2 py-2 rounded-v-lg bg-dark gap-2  flex-1">
            <p className="text-neutral-20  text-[10px] md:text-[16px]">
              جستجوی پیشرفته
            </p>
            <img className="w-5 h-5" src={icons.search} alt="download" />
          </div>
        }
        modal
        nested
      >
        {(close) => (
          <div className="modal-wrapper max-h-[80vh] max-w-[80vw] ">
            <div
              className=" p-2 w-full  mx-auto  overflow-visible no-scrollbar"
              dir="rtl"
            >
              <div className="flex justify-between py-2  ">
                <p className="text-[18px] font-semibold">فیلدهای جستجو</p>
                <button onClick={close}>
                  <img
                    className="cursor-pointer"
                    src={closeIcon}
                    alt="close-icon"
                    width={20}
                    height={20}
                  />
                </button>
              </div>
              <hr />
              <form
                onSubmit={handleSubmit((data) => processForm(data, close))}
                className="flex flex-col"
              >
                <div
                  className={`grid grid-cols-1 md:grid-cols-2 w-full gap-4 my-2   `}
                >
                  <DateInput
                    dateType={"search"}
                    control={control}
                    name={"min_created_at"}
                    label={"تاریخ  ایجاد از"}
                    placeholder={"روز/ماه/سال"}
                    type={"text"}
                    errors={errors.min_created_at}
                    className={""}
                    hour={0}
                    minute={0}
                    second={0}
                  />
                  <DateInput
                    dateType={"search"}
                    control={control}
                    register={register}
                    name={"max_created_at"}
                    label={"تا"}
                    placeholder={"روز/ماه/سال"}
                    type={"text"}
                    errors={errors.max_created_at}
                    className={""}
                    hour={23}
                    minute={59}
                    second={59}
                  />
                </div>
                <div className="grid grid-cols-4 w-full gap-4 my-2"></div>
                <div className="flex flex-row-reverse gap-2  w-fit mr-auto mt-4 text-[12px] md:text-[16px]">
                  <Button
                    className="flex items-center gap-2 mr-auto px-6 py-2 bg-dark hover:bg-slate-600 text-white rounded-[12px] "
                    type="submit"
                  >
                    <p> اعمال</p>
                    <img
                      className="w-5 h-5"
                      src={icons.search}
                      alt="download"
                    />
                  </Button>
                  <Button
                    className=" mr-auto px-6 py-2 border-2 bg-white border-dark hover:bg-slate-200 text-dark rounded-[12px] "
                    tabIndex={"-1"}
                    onClick={(e) => {
                      e.preventDefault();
                      reset(statmentAdvanceSearchDefaultValues);
                    }}
                  >
                    پاک کردن فیلترها
                  </Button>
                </div>
              </form>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default AdvanceSearchBtn;
